export enum AssetListTestId {
    FILTERS_ROW = "asset-filters-row",
    ASSETS_LIST = "asset-list",
    DROPDOWN_SELECT_PREFIX = "asset-select-",
    CLEAR_FILTERS_BTN = "clear-filters",
    LOADER_ID = "asset-list-loader-shimmer",
    NO_RESULTS_FOR_FILTER = "asset-list-filter-missing"
}